export interface ICampaignMember {
	CampaignId?: string;
	ContactId?: string;
	LeadId?: string;
	Status?: string;
}
